import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const ImportantNotice = ({ message, backgroundColor, color, iconColor, iconName, textColor }) => {
    return (
        <React.Fragment>
            <div className="d-flex " style={{ backgroundColor: backgroundColor, border: `1px solid ${color}`, borderRadius: 8, padding: 20, marginTop: 10 }}>
                <div style={{ marginRight: 15 }}>
                    {/* <div className="important-icon-container">  for icon white circle container*/}
                    <div>
                        <Icon icon={iconName || "mdi:information-outline"} style={{ color: iconColor || color, width: 20, height: 20 }} />
                    </div>
                </div>
                <div style={{ fontFamily: 'SophiaPro', fontSize: 14, color: textColor || "#282828", fontWeight: 400 }}>{message}</div>
            </div>
        </React.Fragment>
    );
};

export default ImportantNotice;